import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { formSubmissionData, setFormSubmissionData } from "reduxSlices/formSubmissionSlice"
import { useFormSubmissionFormContext } from "contexts/FormSubmissionFormContext"
import * as API from "services/api"
import { errorToast, successToast } from "components/shared/toast"
import SubmissionEditForm from "./SubmissionEditForm"

const SubmissionEdit = ({ onCancel, onSuccess }) => {
  const dispatch = useDispatch()

  const { answers, slug } = useSelector(formSubmissionData)

  const { formVersionUsedInEdit, setSubmittedFormVersion } = useFormSubmissionFormContext()
  const { id: formVersionUsedInEditId, sections: formVersionUsedInEditSections } = formVersionUsedInEdit

  const updateSubmission = async (data) => {
    const response = await API.updateFormSubmissionAnswers({
      answers: data,
      formVersionId: formVersionUsedInEditId,
      slug,
    })

    if (response.ok) {
      successToast("Form submission successfully updated.")

      // Send the new answers, so that they can be compared
      // to the old answers.
      onSuccess({ answers: data })

      // Set the updated form submission data in redux
      dispatch(setFormSubmissionData(response.data))

      // The version whose questions were just answered is now the submitted version
      setSubmittedFormVersion(formVersionUsedInEdit)

      onCancel()
    } else {
      errorToast("Something went wrong. Unable to update form submission.", response)
    }
  }

  return (
    <SubmissionEditForm
      answers={answers}
      sections={formVersionUsedInEditSections}
      onCancel={onCancel}
      onSubmit={updateSubmission}
    />
  )
}

SubmissionEdit.propTypes = {
  onCancel: types.func.isRequired,
  onSuccess: types.func.isRequired,
}

export default SubmissionEdit
